/* tslint:disable */
/* eslint-disable */
/* @relayHash 093b4c60e64cf7d38760241e26654b15 */

import { ConcreteRequest } from "relay-runtime";
export type STORY_STATUS = "CLOSED" | "OPEN" | "%future added value";
export type UnarchiveStoriesInput = {
    clientMutationId: string;
    storyIDs: Array<string>;
};
export type UnarchiveStoriesMutationVariables = {
    input: UnarchiveStoriesInput;
};
export type UnarchiveStoriesMutationResponse = {
    readonly unarchiveStories: {
        readonly stories: ReadonlyArray<{
            readonly id: string;
            readonly status: STORY_STATUS;
            readonly isArchived: boolean;
            readonly isArchiving: boolean;
        }>;
        readonly clientMutationId: string;
    };
};
export type UnarchiveStoriesMutation = {
    readonly response: UnarchiveStoriesMutationResponse;
    readonly variables: UnarchiveStoriesMutationVariables;
};



/*
mutation UnarchiveStoriesMutation(
  $input: UnarchiveStoriesInput!
) {
  unarchiveStories(input: $input) {
    stories {
      id
      status
      isArchived
      isArchiving
    }
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any)
    ], v1 = [
        ({
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "UnarchiveStoriesPayload",
            "kind": "LinkedField",
            "name": "unarchiveStories",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Story",
                    "kind": "LinkedField",
                    "name": "stories",
                    "plural": true,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "status",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isArchived",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isArchiving",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "clientMutationId",
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any)
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "UnarchiveStoriesMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "UnarchiveStoriesMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "id": "093b4c60e64cf7d38760241e26654b15",
            "metadata": {},
            "name": "UnarchiveStoriesMutation",
            "operationKind": "mutation",
            "text": null
        }
    } as any;
})();
(node as any).hash = '190327a9e930a529091279684e26855c';
export default node;
